import { chartPalette, datetimeXAxis } from '../utils/constants'

export interface CommonChartConfig {
  url: string
  title?: string
}

export const commonChartOptions = {
  colors: chartPalette,
  chart: {
    animation: false,
  },
  scrollbar: {
    showFull: false,
  },
}

export const commonDispersionChartOptions = {
  chart: {
    type: 'scatter',
    zoomType: 'xy',
    animation: false,
  },
  legend: {
    enabled: true,
    itemDistance: 12,
    margin: 3,
    maxHeight: 100,
  },
  plotOptions: {
    series: {
      animation: false,
      cluster: { enabled: true },
      crisp: false,
      dataGrouping: { enabled: false },
      shadow: false,
    },
  },
  stockTools: { gui: { enabled: false } },
}

export const defaultYAxis = {
  id: 'default',
  opposite: false,
  title: { text: '' },
  labels: { format: '{value}' },
}

const percentualYAxis = [
  {
    ...defaultYAxis,
    labels: { format: '{value}%' },
  },
]

export const commonPercentualSeriesConfig = {
  marker: { enabled: false },
  tooltip: { valueDecimals: 2, valueSuffix: '%' },
  type: 'spline',
  yAxis: 'default',
}

export const commonPercentualOptions = {
  colors: chartPalette,
  tooltip: { shared: false, split: true },
  xAxis: datetimeXAxis,
  yAxis: percentualYAxis,
}
